import React, { useState, useCallback } from 'react';
import Layout from 'components/layout';
import CommercialHeader from 'components/header/commercial';
import Benefits from 'components/commercial/benefits';
import GetInTouch from 'components/commercial/get-in-touch';
import SearchOurProperties from 'components/commercial/search-our-properties';
import AutoplaySlides from 'components/autoplay-slides';
import { expCommercialTenant } from 'tenants/definitions/exp/commercial/exp-commercial.tenant';
import Quote from 'components/quote/quote';
import CommercialMetrics from 'components/commercial/metrics';
import InsightsCards from '../exp-components/insights-cards/InsightsCards';

import type { HomePageProps } from '../index';
import type { PropsWithTranslation } from 'types/locales';
import TiltedCards from 'components/tilted-cards';
import CommercialFaq from 'components/commercial/faq';
import CommercialHero from 'components/commercial/hero';

export type HomePageExpCommercialProps = PropsWithTranslation<HomePageProps>;

export default function HomePageExpCommercial({ routeName, t, i18n, tReady }: HomePageExpCommercialProps) {
  const tenant = expCommercialTenant;
  const [showHeader, setShowHeader] = useState(true);
  const commercialBenefits = tenant.config.commercial.benefits;
  const quoteConfig = tenant.config.commercial.quotes.leo;
  const metrics = tenant.config.commercial.metrics;
  const tiltedCardsConfig = tenant.config.home.tiltedCards; // Our Services section

  const handleMinScale = useCallback(() => {
    setShowHeader(true);
  }, []);

  const handleEnter = useCallback(() => {
    setShowHeader(false);
  }, []);

  const handleLeave = useCallback(() => {
    setShowHeader(true);
  }, []);

  const author = {
    name: quoteConfig.authorName,
    title: quoteConfig.authorTitle,
    image: quoteConfig.authorImage,
    imageAlt: quoteConfig.authorImageAlt,
  };
  const quoteStyle = {
    highlightColor: quoteConfig.highlightColor,
  };

  return (
    <Layout routeName={routeName} showMobileBottomNav={false} renderHeader={() => <CommercialHeader showHeader={showHeader} t={t} i18n={i18n} tReady={tReady} />}>
      <CommercialHero
        onMinScale={handleMinScale}
        onEnter={handleEnter}
        onLeave={handleLeave}
        videoSrc={tenant.config.home.heroVideo}
      />
      <Benefits cards={commercialBenefits.benefits} joinUsLink={commercialBenefits.joinUsLink} />
      <SearchOurProperties {...tenant.config.commercial.searchOurProperties} />
      <TiltedCards {...tiltedCardsConfig} />
      <AutoplaySlides {...tenant.config.home.autoplaySlides} />
      <InsightsCards />
      <Quote author={author} content={quoteConfig.quoteContent} style={quoteStyle} t={t} i18n={i18n} tReady={tReady} />
      <CommercialMetrics metrics={metrics} />
      <CommercialFaq 
        faqData={tenant.config.commercial.faq}
        disableHoverExpansion={true}
        t={t}
        tReady={tReady}
        i18n={i18n}
      />
      <GetInTouch />
    </Layout>
  );
}
